import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import  api from '../common/api';

import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  SwitchLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '0.75rem',
    },
  },
  formControl: {
  	margin: 10,
    minWidth: 150,
    fontSize: '0.75rem',
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
});


class Rol extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			dialogOpen: false,
			loading: true,
			errors: false,
			disabled: false,
			password_view: false,
			permissions:[],
			role:{
				id:'',
				permissions:[]
			},
		}
	}
	async componentDidMount() {
		var params = this.getParams();
		var role_id = params.role_id
		var view = params.view
		if (role_id !== '0'){
			await this.getRole(role_id)			
			if (view === '0'){
				this.setState({action: 'edit', disabled: false})
			} else {
				this.setState({disabled: true, action: 'view',})
			}
		} else {
			this.setState({action: 'new', disabled: false})
		}
		await this.getPermissions()			
	}
	getParams(){
		return this.props.match.params
	}

	getRole(id){
	    const token =localStorage.getItem('userToken')
	    return axios
	         .get(api.roles().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	              var role = res.data[0]
	              this.setState({role: role})
	              this.setState({loading: false})
	              return res.data
	          })
	          .catch(err =>{console.log(err)
	          })
	}

	getPermissions(){
	    const token =localStorage.getItem('userToken')
	    return axios
	         .get(api.permissions().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	              var permissions = res.data
	              permissions.map((val, idx)=>{
					var permission = this.state.role.permissions.filter(permission => parseInt(permission.id) === parseInt(val.id));
					if (permission.length > 0){
						val.checked = true
					}
	              })
	              this.setState({permissions: permissions})
	              this.setState({loading: false})
	              return res.data
	          })
	          .catch(err =>{console.log(err)
	          })
	}

 	handlePermissionChange = (e) => {
		var permissions = this.state.permissions
		var element = e.target.name.split('.')
		var key = element[0]
		var id = element[1]
		permissions[id]['checked'] = e.target.checked
		this.setState({permissions: permissions})
 	}

 	handleChange = (event) => {
	    event.preventDefault();	
	    var key = event.target.name
	    var value = event.target.value
	    var role = this.state.role
	    role[key] = value
	    this.setState({role: role})
 	}
 
   handleSubmit = (event) => {
	    event.preventDefault();
	    event.stopPropagation();
	    var formData = new FormData();
		let self = this
		const token =localStorage.getItem('userToken')
		this.state.permissions.map((val,idx)=>{
			if (val.checked === true){
			    formData.set("permissions["+idx+"]", val.id);
			}
		})
		if (this.state.action ==='new'){
		  axios.post(api.roles().post(),
		     formData,
		     {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		     )
		    .then((response)=> {
		        self.setState({errors: false, save_rol: true})
		        self.setState({message: 'Usuario creado con éxito!'})
		        self.setState({dialogOpen: true})
		    })
		    .catch(function (error) {
		        self.setState({errors: true, save_rol: false})
		        var message = ''
				var promise = new Promise(function(resolve, reject) {
					resolve(error);
					if (error.response.data.errors){
						error.response.data.errors.map((val,idx)=>{
							message += val
						})
					} else {
				        message = 'Hubo un problema al guardar el usuario. Por favor volver a intentar'
					}		  		
		  		});

		        self.setState({message: message})
		        self.setState({dialogOpen: true})
		  })
		} else {
		    formData.set("role_id", this.state.role.id);
			axios.post(api.roles().patch(this.state.role.id),
			   formData,
			   {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
			   )
			  .then((response)=> {
			      self.setState({errors: false, save_rol: true})
			      self.setState({message: 'Rol modificado con éxito!'})
			      self.setState({dialogOpen: true})
			  })
			  .catch(function (error) {
		        var message = ''
				var promise = new Promise(function(resolve, reject) {
					resolve(error);
					if (error.response.data.errors){
						error.response.data.errors.map((val,idx)=>{
							message += val
						})
					} else {
				        message = 'Hubo un problema al guardar el rol. Por favor volver a intentar'
					}		  		
		  		});

		        self.setState({message: message})

			      self.setState({errors: true, save_rol: false})
			      self.setState({message: 'Hubo un problema al guardar el rol. Por favor volver a intentar'})
			      self.setState({dialogOpen: true})
			})

		}
	}

	render(){
	    const handleRedirect = () =>{
	      window.location.href=`/users`
	    }

	    const handleDialogClose = () => {
	      this.setState({dialogOpen: false})
	    }        
		const { classes } = this.props;
	    const disabled = this.state.disabled
	    const { role }  = this.state
		return(
	       <Container fluid className="main-content-container px-4 pb-4">
	          <Row noGutters className="page-header pt-4">
	            <PageTitle sm="4" title={"Rol"} className="text-sm-left" />
	          </Row>
	          <Row>
	            <Col md="12">
	              <React.Fragment>
	              {(this.state.dialogOpen)?
	                <Dialog
	                  open={this.state.dialogOpen}
	                  fullWidth
	                  aria-labelledby="responsive-dialog-title"
	                >
	                  <DialogTitle id="responsive-dialog-title">{"Rol"}</DialogTitle>
	                  <DialogContent>
	                    <DialogContentText>
	                        {this.state.message}
	                    </DialogContentText>
	                  </DialogContent>
	                  <DialogActions disableSpacing="false">  
                      {(this.state.save_rol)?
                        <Button onClick={handleRedirect} variant="contained" color="primary" >
                            Aceptar
                        </Button>
                        :
                        ''
                       }
	                  {(this.state.errors) ?
	                      <Button onClick={handleDialogClose} variant="contained" color="primary" >
	                          Aceptar
	                      </Button>
	                      :
	                      ''
	                    }
	                  </DialogActions>
	                </Dialog>
	              :''}
	              {(this.state.loading)?
	                 <LinearProgress /> 
	              :
	              <div>
	                <form onSubmit={this.handleSubmit}>
	                	<div className="row ml-1">
							<TextField
								id="name"
								name="name"
								label="Nombre"
								disabled={true}
								type="text"
								required
								placeholder="Ingrese el nombre"
								onChange={this.handleChange}
								value={role.name}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
						</div>
						<div>
						{(this.state.permissions.map((val, idx)=>{

								return (
									<div>
									  <FormControlLabel
        									control={<Switch
											    id={'permission_id.'+idx}
											    value={val.checked}
											    checked={val.checked}
											    name={'permission_id.'+idx}
									   		    disabled={this.state.disabled}	
									   		    label={val.name}
									   		    onChange={this.handlePermissionChange}          
											    size="small"
											    color="primary"
											    className="ml-2 mr-4"
											    inputProps={{ 'aria-label': 'primary checkbox' }}
											  />}
										  	label={val.name}
											labelPlacement="start"
										  />
									  </div>

								)

						}))}
						</div>


		                {(this.state.action !== 'view')?
		                  <React.Fragment>
		                    <Button type="submit" variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
		                      Guardar
		                    </Button>
		                    <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/users"}>
		                      Cancelar
		                    </Button>
		                  </React.Fragment>
		                :
		                  <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/users"}>
		                    Volver
		                  </Button>
		                }
	              </form>
	            </div>
	            }
	            </React.Fragment>
	          </Col>
	        </Row>
	      </Container>

		)
	}  

}

export default withStyles(styles)(Rol);